<app-dashboard-wrapper
  title="{{
    'dashboard-new-bank-account.component.new_bank_account_title'
      | localise: 'New Bank Account'
  }}">
  <app-add-new-bank-account
    redirectForNotConfirmedToken="/bank-accounts"
    class="forms-support-dark-mode"></app-add-new-bank-account>
</app-dashboard-wrapper>
